import css from './defaultTreeGroup.module.css'

const defaultTreeGroupStyling = {
  groupClassname: css.groupWrapper,
}
export default defaultTreeGroupStyling
